module.exports = __webpack_public_path__ + "components/resort-finder/static/icon__cards-c84260ca00c5fa70f892df95950ba967.svg";